import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import NotificacaoList from './NotificacaoList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import NotificacaoCadastrar from './NotificacaoCadastrar';
import { Messages } from 'primereact/messages';
import postNotificacao from "../../service/postNotificacao";
import putNotificacao from '../../service/putNotificacao';

export default function NotificacaoPage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [notificacao, setNotificacao] = useState<any | null>(null);
  const labelButton = t('cadastrar')
  const saveNotificacao = (notificacao:any) => {
    if(notificacao.id){
      putNotificacao(notificacao).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setNotificacao(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    else{
      postNotificacao(notificacao).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setNotificacao(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    
    
  }
  const startContent = (
    <React.Fragment>
        <Button label={labelButton} icon="pi pi-plus" style={{backgroundColor:'#183462'}} onClick={() => {setNotificacao({})}}/>
    </React.Fragment>
);

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-megaphone" style={{ fontSize: '2.0rem' }}></i> {t('notificacoes')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!notificacao && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <NotificacaoList onEdit={(notificacao:any) => { setNotificacao(notificacao);}}></NotificacaoList>
          </>
        )}
        {notificacao && (
          <>
           <NotificacaoCadastrar msgs={msgs} notificacao={notificacao} onSave={saveNotificacao} onClose={() => {setNotificacao(null)}}></NotificacaoCadastrar>
          </>
        )}
      </div>
                
    </Container>
  )
}
